export const INACTIVE_ACCOUNT_MESSAGE =
  'Your account is inactive. Please contact an administrator.';

const NOTICE_KEY = 'merchant_admin_inactive_account_notice';

export const isInactiveAccountResponse = payload => Boolean(payload) && (
  Number(payload.status) === 14
  || Number(payload.error_code) === 14
  || payload.error === 'account_inactive'
  || payload.status === 'ACCOUNT_INACTIVE'
);

export const rememberInactiveAccountNotice = () => {
  try {
    window.sessionStorage.setItem(NOTICE_KEY, INACTIVE_ACCOUNT_MESSAGE);
  } catch (error) {
    // The redirect still terminates the session when browser storage is unavailable.
  }
};

export const consumeInactiveAccountNotice = () => {
  try {
    const notice = window.sessionStorage.getItem(NOTICE_KEY);
    window.sessionStorage.removeItem(NOTICE_KEY);
    return notice;
  } catch (error) {
    return null;
  }
};
